export const listEnabledBillingProviders = `
   query listEnabledBillingProviders($limit: Int, $nextToken: String, $sort: SortInput) {
       listEnabledBillingProviders(limit: $limit, nextToken: $nextToken, sort: $sort) {
           items {
              id
              key
              name
              description
              status
           }
           nextToken
       }
   }
`;

export const getBillingProvider = `
   query getBillingProvider($id: ID!) {
       getBillingProvider(id: $id) {
           id
           key
           name
           description
           status
       }
   }
`;
